import { setContext } from '@apollo/client/link/context';
import { getOperationName } from '@apollo/client/utilities';
import { defaultLocalStorageAdapter } from '@hover/graphql';

import { AuthenticationInfoDocument } from 'src/shared/graphql/generated';
import { isDefined } from 'src/shared/helpers/lists';

const excludedQueries = [AuthenticationInfoDocument] as const;
const excludedOperations = excludedQueries
  .map(getOperationName)
  .filter(isDefined);

const link = setContext(async ({ operationName }, { headers }) => {
  const excluded = operationName
    ? excludedOperations.includes(operationName)
    : false;

  const token = excluded
    ? null
    : await defaultLocalStorageAdapter.getAccessToken();

  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    headers: token
      ? {
          ...headers,
          'X-JWT-AUTH': `Bearer ${token}`,
        }
      : headers,
  };
});

export { link };
